<template>
  <div style="height: 500px">
    <div class="m-4 folder-container w-100" type="flex" v-if="!viewImages">
      <div v-if="folders.length == 0" class="emptyFolder">
        <span>Thư mục trống</span>
      </div>
      <div class=" w-100">
        <div class="d-flex flex-wrap">
          <div class="folder-list-item " v-for="folder in folders" :key="folder.id">
            <div class="d-flex flex-column w-100 h-100">
              <div style="height: 120px" class="pointer" @click="selectFolder(folder)">
                <img class="mt-3" :size="64" src="/assets/icon/icon-folder.svg" />
              </div>
              <div
                style="height: 40px;background-color: #EAECF2;line-height: 40px;text-align: left;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;"
                class="font-size-14 fw-bold px-2 flex-grow-1">{{ folder.name }}
              </div>
            </div>
          </div>


          <div class="mt-2 mx-4 align-self-center text-center pointer"
               @click="$router.push('/setting#library')">
            <div>
              <i style="font-size: 60px; color: #CCCCCC " class="el-icon-circle-plus"></i>
            </div>
            <span> Quản lý thư viện</span>
          </div>
        </div>
      </div>
    </div>
    <div class="m-4 mt-1" v-else>
      <div class="my-2 d-flex">
        <div class="flex-grow-1">
          <div class="d-flex" style="line-height: 40px">
            <div class="el-icon-back text-primary font-size-24 pointer" style="line-height: 40px"
                 @click="goBack()"></div>
            <div class="font-size-14  text-primary mx-2 pointer" @click="goBack()">Thư viện hình ảnh</div>
            <div class="font-size-14 flex-grow-1">/ {{ selectedFolder.name }}</div>
          </div>
          <div class="small-scrollbar">
            <div class="d-flex flex-wrap">
              <div v-if="images.length > 0" class="d-flex flex-wrap"
                   style="min-height: 200px;max-height: 200px;overflow-y: auto;">
                <div v-for="image in images" :key="image">
                  <div class=" pointer" style="position: relative" @click="selectImage(image)">
                    <el-image class="image-list-item" fit="cover" :src="getUrlImage(image)" lazy />

                    <el-checkbox :value="checkImage(image)" size="medium"
                                 style="position: absolute;right: 20px;bottom: 20px;" />
                  </div>
                </div>
              </div>
              <div v-if="fileNameList.length > 0"
                   style="min-height: 150px;max-height: 150px;overflow-y: auto;">
                <div v-for="name in fileNameList" :key="name">
                  <div class="pointer" style="position: relative" @click="selectImage(name)">
                    <div class=" position-relative">
                      <File :id="substr(name)" />
                    </div>
                    <el-checkbox :value="checkImage(name)" size="medium"
                                 style="position: absolute;right: 12px;top: 45px;" />
                  </div>
                </div>
              </div>
            </div>

            <div v-if="fileNameList.length === 0 && images.length === 0" class="emptyFolder mt-5 font-size-14">
              Empty
            </div>

            <h6 class="mt-3"> Ảnh/File được chọn</h6>
            <div v-if="selectedImages.length > 0" class="d-flex flex-wrap"
                 style="max-height: 110px;overflow-y: auto;">
              <div v-for="image in selectedImages" :key="image">
                <div class="position-relative pointer" style="position: relative">
                  <File v-if="image.includes('file')" :id="substr(image)" />
                  <el-image v-else class="image-list-item rounded-1" style="max-width: 80px;max-height: 80px"
                            fit="cover" @click="newTab(image)" :src="getUrlImage(image)" lazy />
                  <i class="icon-hover el-icon-error font-size-16 pointer position-absolute" style="top:5px; right:10px"
                     @click="removeImage(image)" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div style="border-top: #DCDFE9 1px solid " class="my-2"></div>
      <div class="">
        <div class="flex-grow-1">
          <el-button type="primary" v-if="selectedImages.length > 0" size="medium" class="float-end mx-2"
                     @click="send()">Gửi ({{ selectedImages.length }})
          </el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>


import Config from "../lib/Config";
import File from "./imageLibSetting/File";

export default {
  components: { File },
  props: ["conversation"],
  data() {
    return {
      folders: [],
      images: [],
      selectedImages: [],
      hoverFolder: {},
      selectedFolder: {},
      folder: {
        id: 0,
        name: ""
      },
      openFolderId: 0,
      viewImages: false,
      fileList: [],
      checkedImage: true,
      fileNameList: []
    };
  },
  methods: {

    newTab(item) {
      window.open(this.getUrlImage(item), "_blank", "toolbar=0,location=0,menubar=0");
    },

    substr(name) {
      let url = name.slice(0, -4);
      return url;
    },

    getUrlImage(image) {
      let HOST = "";
      if (Config.DEV) {
        HOST = Config.HOST;
      } else {
        HOST = "https://zalo.salework.net";
      }
      return HOST + "/api/image/" + image;
    },
    async sendMsgFile(id) {
      var bodyFormData = new FormData();
      bodyFormData.append("conversationId", this.conversation.id);
      bodyFormData.append("id", id);
      bodyFormData.append("accountId", this.conversation.accountId);
      bodyFormData.append("toId", this.conversation.toId);
      bodyFormData.append("isGroup", this.conversation.group);
      await this.$http.post("/api/message/sendFileFromLibrary", bodyFormData);
    },
    async send() {
      if (this.selectedImages.length > 1) {
        let groupMsgId = new Date().getTime();

        let totalItems = this.selectedImages.filter(s => !s.includes("file"));
        let totalFiles = this.selectedImages.filter(s => s.includes("file"));
        totalFiles.forEach(s => {
          this.sendMsgFile(this.substr(s));
        });

        let index = 0;
        for (let selectedImage of totalItems) {
          this.sendMsgPhoto(selectedImage, groupMsgId, totalItems.length, index);
          index += 1;
        }
      } else {
        if (this.selectedImages[0].includes("file")) {
          this.sendMsgFile(this.substr(this.selectedImages[0]));
        } else {
          this.sendMsgPhoto(this.selectedImages[0], 0, 0, 0);
        }
      }
      this.$emit("closeImagePopup");
    },

    async sendMsgPhoto(selectedImage, groupMsgId, totalItems, idInGroup) {
      await this.$http.get("/api/message/sendPhoto", {
        params: {
          conversationId: this.conversation.id,
          id: selectedImage,
          accountId: this.conversation.accountId,
          toId: this.conversation.group !== true ? this.conversation.toId : null,
          groupId: this.conversation.group === true ? this.conversation.toId : null,
          idInGroup: idInGroup,
          totalItems: totalItems,
          groupMsgId: groupMsgId
        }
      });
    },

    checkImage(item) {
      let index = this.selectedImages.indexOf(item);
      if (index > -1) {
        return true;
      }
      return false;
    },

    removeImage(item) {
      let i = this.selectedImages.map((item) => item).indexOf(item);
      this.selectedImages.splice(i, 1);
    },
    selectImage(image) {
      let index = this.selectedImages.indexOf(image);
      if (index > -1) {
        this.selectedImages.splice(index, 1);
      } else {
        this.selectedImages.push(image);
      }
    },
    getFiles(isCommon) {
      let params = isCommon ? "0" : this.conversation.accountId;
      this.fileNameList = [];
      this.$http.get("/api/image/file?accountId=" + params + "&folderId=" + this.selectedFolder.id)
        .then(response => {
          response.data.forEach(s => {
            s = s + "file";
            this.fileNameList.push(s);
          });
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },
    fetchFolders() {
      this.$http.get("/api/folder?accountId=" + this.conversation.accountId)
        .then((response) => {
          response.data.forEach(s => {
            s.isCommon = false;
            this.folders.push(s);
          });
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
      this.$http.get("/api/folder?accountId=0")
        .then((response) => {
          response.data.forEach(s => {
            s.isCommon = true;
            this.folders.push(s);
          });
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    },

    selectFolder(folder) {
      this.selectedFolder = folder;
      this.viewImages = true;
      this.fetchImages(folder.isCommon);
      this.getFiles(folder.isCommon);
    },
    goBack() {
      this.viewImages = false;
    },
    fetchImages(isCommon) {
      let params = isCommon ? "0" : this.conversation.accountId;
      this.$http.get("/api/image?accountId=" + params + "&folderId=" + this.selectedFolder.id)
        .then((response) => {
          this.images = response.data;
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra");
        });
    }
  },
  created() {
    if (this.conversation.accountId > 0) {
      this.fetchFolders();
    }
  }
};
</script>
